import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveTaxaFailure, saveTaxaSuccess, updateTaxaFailure, updateTaxaSuccess } from './actions';

export function* saveTaxa({ payload }) {
  try {
    yield call(api.post, 'api/taxa', payload.data, { withCredentials: true });

    yield put(saveTaxaSuccess());

    toast.success('TAXA criado com sucesso!')

    history.push('/specifications/cartoes/resources/taxa');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveTaxaFailure());
  }
}

export function* updateTaxa({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/taxa/${id}`, payload.data, { withCredentials: true });

    yield put(updateTaxaSuccess());

    toast.success('TAXA atualizado com sucesso!')

    history.push('/specifications/cartoes/resources/taxa');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateTaxaFailure());
  }
}

export default all([
  takeLatest('@taxa/SAVE_REQUEST', saveTaxa),
  takeLatest('@taxa/UPDATE_REQUEST', updateTaxa)
]);